// Markdown editor with live preview (snarkdown) + autosave.
import snarkdown from "snarkdown";
import { el, btn, ta, wrap, copy, saveFlag } from "./ui.js";
import { readJSON, writeJSON } from "../shared/store.js";

const KEY = "revault:markdown";
const SAMPLE = "# Hello\n\nType **Markdown** on the left and see it _rendered_ on the right.\n\n- Lists\n- [Links](https://example.com)\n- `code`\n\n> Blockquotes too.";

export function markdown(root) {
	const s = wrap(root); s.classList.add("rv-md");
	const saved = readJSON(KEY, null);
	const editor = ta({ spellcheck: true }); editor.classList.add("rv-md-editor");
	editor.setAttribute("aria-label", "Markdown");
	editor.value = typeof saved === "string" ? saved : SAMPLE;
	const preview = el("div", "rv-md-preview");
	preview.setAttribute("role", "region");
	preview.setAttribute("aria-label", "Preview");
	const flag = saveFlag();

	function rerender() {
		try { preview.innerHTML = snarkdown(editor.value); } catch (e) { preview.textContent = ""; }
		flag.set(writeJSON(KEY, editor.value));
	}
	editor.addEventListener("input", rerender);

	const bar = el("div", "rv-trow");
	bar.append(btn("Copy Markdown", () => copy(editor.value), "rv-tbtn"), btn("Copy HTML", () => copy(preview.innerHTML), "rv-tbtn"), btn("Clear", () => { editor.value = ""; rerender(); }, "rv-tbtn"));
	const split = el("div", "rv-md-split"); split.append(editor, preview);
	s.append(bar, flag, split);
	rerender();
}
